export default "__VITE_ASSET__3f2708d1__"